import { css } from 'styled-components'

export default css`
  &.MileageRouteSection {
    display: flex;
    flex-direction: column;
    gap: 32px;

    .map-toggle-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .stop-row {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      position: relative;

      &.dragging {
        opacity: 0.4;
      }
    }

    .drag-handle {
      display: flex;
      align-items: center;
      padding-bottom: 18px;
      cursor: grab;

      &:active {
        cursor: grabbing;
      }
    }

    .stop-field {
      flex: 1;
      position: relative;
    }

    .drop-target .stop-field::before {
      content: '';
      position: absolute;
      top: -2px;
      left: 0;
      right: 0;
      height: 2px;
      background: #d1d5db;
      border-radius: 1px;
      z-index: 1;
    }

    .static-map-image {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 8px;
    }

    .route-error {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-top: 8px;
      font-size: 14px;
      color: #d5404a;
    }

    .route-loading {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 0;
      font-size: 14px;
      color: #6b7280;
    }
  }
`
